var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-table',{attrs:{"url":"/api/v1/news","attributes":[
    {
      attribute: 'title',
      name: 'Titel'
    },
    {
      attribute: 'article',
      name: 'Artikel',
      type: 'ShortenTextCell'
    },
    {
      attribute: 'release_time',
      name: 'release_time',
      type: 'DateTimeCell'
    },
    {
      attribute: 'update_page_url',
      name: 'Bearbeiten',
      type: 'ActionCell',
      label: 'Bearbeiten',
      sortable: false
    },
    {
      attribute: 'update_url',
      name: 'Löschen',
      type: 'DeleteCell',
      label: 'Löschen',
      sortable: false
    }
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }